// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"d02051e4","651":"86d66c21"}[chunkId] + ".chunk.js";
};